export const Routes = {
  home: "/",
  mailUnsubscribe: "/unsubscribedigestemail",
  firstLogin: "/firstlogin",
  overview: "/overview/:id?",
  overviewAll: "/overview",
  sales: "/performance",
  product: "/product",
  installation: "/installation",
  settings: "/settings",
  profile: "/settings/profile",
  users: "/settings/users",
  outlets: "/settings/outlets",
  devices: "/settings/devices",
  login: "/login",
  logout: "/logout"
};
export default Routes;
